module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('Board', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playing),
      expression: "playing"
    }],
    ref: "board",
    on: {
      "restart": _vm.restart
    }
  }), _vm._v(" "), _c('OptionsPane', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.playing),
      expression: "!playing"
    }],
    ref: "optionsPane",
    on: {
      "gameStart": _vm.start
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("???")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee47905a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 35
// module chunks = 1